module.exports = __webpack_public_path__ + "static/media/ky.c2486cf5.svg";